import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { HOME_QUALITY_COMPARISON_MAP, baseBindState } from './lib/helpers';

export const homeQualityVerification = defineInternalTask({
  taskName: internalTasks.HomeQualityVerification,
  config: {
    staffDisplayName: 'Home quality: review needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['H'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const offerHome = offer?.quote?.home;
      const homeQualityFromOffer = offerHome?.homeQuality;
      const veriskData = offer?.characteristicsData?.normalizedProviderData?.verisk;
      // Guard against non-array verisk data — optional chaining only protects
      // against null/undefined, not against an object missing .find().
      const homeQualityFromData = Array.isArray(veriskData)
        ? veriskData.find((c) => c.attribute === 'structQuality')?.value
        : undefined;

      if (
        !homeQualityFromData ||
        !homeQualityFromOffer ||
        HOME_QUALITY_COMPARISON_MAP[homeQualityFromData] === undefined ||
        HOME_QUALITY_COMPARISON_MAP[homeQualityFromOffer] === undefined
      ) {
        return null;
      }

      const delta = Math.abs(
        HOME_QUALITY_COMPARISON_MAP[homeQualityFromData] - HOME_QUALITY_COMPARISON_MAP[homeQualityFromOffer]
      );
      if (delta <= 1) {
        return null;
      }

      return {
        data: { homeQualityFromData, homeQualityFromOffer },
        bindState: baseBindState(policy)
      };
    },
    description: ({ data }) =>
      `We need to investigate and confirm home quality matches selected home quality, as home quality changed significantly during quoting process

Original home quality: ${data.homeQualityFromData}
New home quality: ${data.homeQualityFromOffer}`
  }
});
